// // import { useEffect, useState, useCallback } from "react";
// // import {
// //   Activity,
// //   AlertTriangle,
// //   CheckCircle,
// //   RefreshCw,
// //   Filter,
// //   Wifi,
// //   WifiOff,
// // } from "lucide-react";
// // import KPICard from "../../components/charts/KPICard";
// // import { weightAPI, dashboardAPI, companyAPI } from "../../services/api";
// // import { useAuth } from "../../context/AuthContext";
// // import {
// //   AreaChart,
// //   Area,
// //   LineChart,
// //   Line,
// //   BarChart,
// //   Bar,
// //   XAxis,
// //   YAxis,
// //   CartesianGrid,
// //   Tooltip,
// //   ResponsiveContainer,
// //   Legend,
// // } from "recharts";

// // const REFRESH_INTERVAL = 10000;

// // export default function ClientDashboard() {
// //   const { user } = useAuth();

// //   const [recentData, setRecentData] = useState(null); // recent entries table sathi
// //   const [analytics, setAnalytics] = useState(null); // charts + KPIs sathi
// //   const [vendors, setVendors] = useState([]);

// //   const [selectedVendor, setSelectedVendor] = useState("");
// //   const [days, setDays] = useState(7);
// //   const [loading, setLoading] = useState(true);
// //   const [err, setErr] = useState("");
// //   const [lastUpdated, setLastUpdated] = useState(null);
// //   const [live, setLive] = useState(true);

// //   // Vendor list
// //   useEffect(() => {
// //     companyAPI
// //       .list()
// //       .then((r) => setVendors(r.data || []))
// //       .catch(() => setVendors([]));
// //   }, []);

// //   // Recent entries (table sathi)
// //   const fetchRecent = useCallback(async () => {
// //     try {
// //       const params = { limit: 10 };
// //       if (selectedVendor) params.company_id = selectedVendor;
// //       const r = await weightAPI.list(params);
// //       setRecentData(r.data);
// //     } catch (e) {
// //       console.error("Recent data fetch failed:", e.message);
// //     }
// //   }, [selectedVendor]);

// //   // Analytics (KPIs + charts sathi)
// //   const fetchAnalytics = useCallback(
// //     async (silent = false) => {
// //       if (!silent) setLoading(true);
// //       try {
// //         const r = await dashboardAPI.analytics(days, selectedVendor || null);
// //         setAnalytics(r.data);
// //         setLastUpdated(new Date());
// //         setErr("");
// //       } catch (e) {
// //         setErr(e.message);
// //       } finally {
// //         setLoading(false);
// //       }
// //     },
// //     [days, selectedVendor],
// //   );

// //   useEffect(() => {
// //     fetchAnalytics();
// //     fetchRecent();
// //   }, [selectedVendor, days, fetchAnalytics, fetchRecent]);

// //   useEffect(() => {
// //     if (!live) return;
// //     const interval = setInterval(() => {
// //       fetchAnalytics(true);
// //       fetchRecent();
// //     }, REFRESH_INTERVAL);
// //     return () => clearInterval(interval);
// //   }, [live, fetchAnalytics, fetchRecent]);

// //   if (loading && !analytics)
// //     return <div style={{ padding: 28, color: "var(--text2)" }}>Loading...</div>;
// //   if (err && !analytics)
// //     return (
// //       <div style={{ padding: 28, color: "var(--danger)" }}>Error: {err}</div>
// //     );

// //   // ── KPIs: analytics.daily madhe saglya days cha sum ────────
// //   const daily = analytics?.daily || [];
// //   const hourly = analytics?.hourly || [];
// //   const vendor = analytics?.vendor || [];
// //   const part = analytics?.part || [];

// //   const totalChecks = daily.reduce((s, d) => s + d.qc_pass + d.qc_fail, 0);
// //   const totalPassed = daily.reduce((s, d) => s + d.qc_pass, 0);
// //   const totalFailed = daily.reduce((s, d) => s + d.qc_fail, 0);
// //   const passRate =
// //     totalChecks > 0 ? ((totalPassed / totalChecks) * 100).toFixed(1) : "0.0";

// //   // Chart data
// //   const dailyChart = daily.map((d) => ({
// //     day: new Date(d.day).toLocaleDateString("en-IN", {
// //       month: "short",
// //       day: "numeric",
// //     }),
// //     Pass: d.qc_pass,
// //     Fail: d.qc_fail,
// //   }));
// //   const hourlyChart = hourly.map((h) => ({
// //     hour: `${String(h.hour).padStart(2, "0")}:00`,
// //     Total: h.total_inspected,
// //     Passed: h.passed,
// //     Failed: h.total_inspected - h.passed,
// //   }));
// //   const vendorChart = vendor.map((v) => ({
// //     name:
// //       v.vendor_name?.length > 14
// //         ? v.vendor_name.slice(0, 14) + "…"
// //         : v.vendor_name,
// //     Pass: v.qc_pass,
// //     Fail: v.qc_fail,
// //   }));
// //   const partChart = part.map((p) => ({
// //     name: p.product_code || p.product_name?.slice(0, 10),
// //     Pass: p.qc_pass,
// //     Fail: p.qc_fail,
// //   }));

// //   const tooltipStyle = {
// //     contentStyle: {
// //       background: "var(--surface)",
// //       border: "1px solid var(--border2)",
// //       borderRadius: 8,
// //     },
// //     labelStyle: { color: "var(--text2)", fontSize: 11 },
// //   };

// //   return (
// //     <div style={{ padding: 28 }}>
// //       {/* Header */}
// //       <div
// //         style={{
// //           display: "flex",
// //           justifyContent: "space-between",
// //           alignItems: "flex-start",
// //           marginBottom: 24,
// //         }}
// //       >
// //         <div>
// //           <h1
// //             style={{ fontSize: 20, fontWeight: 700, letterSpacing: "-0.02em" }}
// //           >
// //             Welcome, {user?.name}
// //           </h1>
// //           <p style={{ color: "var(--text2)", fontSize: 13, marginTop: 2 }}>
// //             {user?.company_name || "Your quality dashboard"}
// //           </p>
// //         </div>
// //         <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
// //           {lastUpdated && (
// //             <span style={{ fontSize: 11, color: "var(--text3)" }}>
// //               Updated {lastUpdated.toLocaleTimeString()}
// //             </span>
// //           )}
// //           <button
// //             onClick={() => setLive((l) => !l)}
// //             title={live ? "Pause live updates" : "Resume live updates"}
// //             style={{
// //               display: "flex",
// //               alignItems: "center",
// //               justifyContent: "center",
// //               padding: "8px",
// //               borderRadius: 6,
// //               border: "1px solid var(--border2)",
// //               background: live ? "rgba(16,185,129,0.1)" : "rgba(239,68,68,0.1)",
// //               color: live ? "var(--success)" : "var(--danger)",
// //               cursor: "pointer",
// //             }}
// //           >
// //             {live ? <Wifi size={14} /> : <WifiOff size={14} />}
// //           </button>
// //           <button
// //             onClick={() => {
// //               fetchAnalytics();
// //               fetchRecent();
// //             }}
// //             title="Refresh"
// //             style={{
// //               display: "flex",
// //               alignItems: "center",
// //               justifyContent: "center",
// //               padding: "8px",
// //               borderRadius: 6,
// //               border: "1px solid var(--border2)",
// //               background: "var(--surface)",
// //               color: "var(--text2)",
// //               cursor: "pointer",
// //             }}
// //           >
// //             <RefreshCw size={14} />
// //           </button>
// //         </div>
// //       </div>

// //       {/* ── KPI Cards — analytics data वरून (real numbers!) ── */}
// //       <div
// //         className="dashboard-cards-grid"
// //         style={{
// //           display: "grid",
// //           gridTemplateColumns: "repeat(4, 1fr)",
// //           gap: 14,
// //           marginBottom: 24,
// //         }}
// //       >
// //         <KPICard
// //           label={`Total Checks (${days}d)`}
// //           value={totalChecks}
// //           icon={Activity}
// //           color="var(--accent)"
// //         />
// //         <KPICard
// //           label="Passed"
// //           value={totalPassed}
// //           icon={CheckCircle}
// //           color="var(--success)"
// //         />
// //         <KPICard
// //           label="Failed"
// //           value={totalFailed}
// //           icon={AlertTriangle}
// //           color="var(--danger)"
// //         />
// //         <KPICard
// //           label="Pass Rate"
// //           value={passRate}
// //           unit="%"
// //           icon={CheckCircle}
// //           color="var(--warn)"
// //         />
// //       </div>

// //       {/* Vendor + Days Filter */}
// //       <div
// //         className="flex-responsive"
// //         style={{
// //           display: "flex",
// //           alignItems: "center",
// //           gap: 10,
// //           marginBottom: 20,
// //           padding: "10px 14px",
// //           background: "var(--surface)",
// //           border: "1px solid var(--border)",
// //           borderRadius: 8,
// //         }}
// //       >
// //         <Filter size={14} color="var(--text3)" />
// //         <span style={{ fontSize: 12, color: "var(--text3)", fontWeight: 500 }}>
// //           Filter:
// //         </span>
// //         <select
// //           value={selectedVendor}
// //           onChange={(e) => setSelectedVendor(e.target.value)}
// //           style={{
// //             padding: "4px 10px",
// //             borderRadius: 6,
// //             border: "1px solid var(--border2)",
// //             background: "var(--surface)",
// //             color: "var(--text)",
// //             fontSize: 12,
// //             cursor: "pointer",
// //           }}
// //         >
// //           <option value="">All Companies</option>
// //           {vendors.map((v) => (
// //             <option key={v.id} value={v.id}>
// //               {v.name}
// //             </option>
// //           ))}
// //         </select>
// //         {[7, 14, 30].map((d) => (
// //           <button
// //             key={d}
// //             onClick={() => setDays(d)}
// //             style={{
// //               padding: "4px 10px",
// //               borderRadius: 6,
// //               fontSize: 12,
// //               border:
// //                 days === d
// //                   ? "1px solid var(--accent)"
// //                   : "1px solid var(--border2)",
// //               background:
// //                 days === d ? "rgba(59,130,246,0.1)" : "var(--surface)",
// //               color: days === d ? "var(--accent)" : "var(--text2)",
// //               cursor: "pointer",
// //               fontWeight: days === d ? 600 : 400,
// //             }}
// //           >
// //             {d}d
// //           </button>
// //         ))}
// //       </div>

// //       {/* Charts Row 1 */}
// //       <div
// //         className="dashboard-charts-grid"
// //         style={{
// //           display: "grid",
// //           gridTemplateColumns: "1fr 1fr",
// //           gap: 16,
// //           marginBottom: 16,
// //         }}
// //       >
// //         <div className="card">
// //           <h3
// //             style={{
// //               fontSize: 13,
// //               fontWeight: 600,
// //               marginBottom: 16,
// //               color: "var(--text2)",
// //             }}
// //           >
// //             Daily QC Trend (Last {days} days)
// //           </h3>
// //           {dailyChart.length === 0 ? (
// //             <p
// //               style={{
// //                 color: "var(--text3)",
// //                 fontSize: 12,
// //                 textAlign: "center",
// //                 padding: 32,
// //               }}
// //             >
// //               No data
// //             </p>
// //           ) : (
// //             <ResponsiveContainer width="100%" height={180}>
// //               <AreaChart
// //                 data={dailyChart}
// //                 margin={{ top: 4, right: 4, bottom: 0, left: -20 }}
// //               >
// //                 <defs>
// //                   <linearGradient id="passGrad" x1="0" y1="0" x2="0" y2="1">
// //                     <stop offset="5%" stopColor="#10b981" stopOpacity={0.25} />
// //                     <stop offset="95%" stopColor="#10b981" stopOpacity={0} />
// //                   </linearGradient>
// //                   <linearGradient id="failGrad" x1="0" y1="0" x2="0" y2="1">
// //                     <stop offset="5%" stopColor="#ef4444" stopOpacity={0.25} />
// //                     <stop offset="95%" stopColor="#ef4444" stopOpacity={0} />
// //                   </linearGradient>
// //                 </defs>
// //                 <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
// //                 <XAxis
// //                   dataKey="day"
// //                   tick={{ fill: "var(--text3)", fontSize: 10 }}
// //                   axisLine={false}
// //                   tickLine={false}
// //                 />
// //                 <YAxis
// //                   tick={{ fill: "var(--text3)", fontSize: 10 }}
// //                   axisLine={false}
// //                   tickLine={false}
// //                 />
// //                 <Tooltip {...tooltipStyle} />
// //                 <Legend wrapperStyle={{ fontSize: 11 }} />
// //                 <Area
// //                   type="monotone"
// //                   dataKey="Pass"
// //                   stroke="#10b981"
// //                   fill="url(#passGrad)"
// //                   strokeWidth={2}
// //                   dot={false}
// //                 />
// //                 <Area
// //                   type="monotone"
// //                   dataKey="Fail"
// //                   stroke="#ef4444"
// //                   fill="url(#failGrad)"
// //                   strokeWidth={2}
// //                   dot={false}
// //                 />
// //               </AreaChart>
// //             </ResponsiveContainer>
// //           )}
// //         </div>

// //         <div className="card">
// //           <h3
// //             style={{
// //               fontSize: 13,
// //               fontWeight: 600,
// //               marginBottom: 16,
// //               color: "var(--text2)",
// //             }}
// //           >
// //             Hourly Inspections (Today)
// //           </h3>
// //           {hourlyChart.length === 0 ? (
// //             <p
// //               style={{
// //                 color: "var(--text3)",
// //                 fontSize: 12,
// //                 textAlign: "center",
// //                 padding: 32,
// //               }}
// //             >
// //               No data yet today
// //             </p>
// //           ) : (
// //             <ResponsiveContainer width="100%" height={180}>
// //               <LineChart
// //                 data={hourlyChart}
// //                 margin={{ top: 4, right: 4, bottom: 0, left: -20 }}
// //               >
// //                 <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
// //                 <XAxis
// //                   dataKey="hour"
// //                   tick={{ fill: "var(--text3)", fontSize: 10 }}
// //                   axisLine={false}
// //                   tickLine={false}
// //                 />
// //                 <YAxis
// //                   tick={{ fill: "var(--text3)", fontSize: 10 }}
// //                   axisLine={false}
// //                   tickLine={false}
// //                 />
// //                 <Tooltip {...tooltipStyle} />
// //                 <Legend wrapperStyle={{ fontSize: 11 }} />
// //                 <Line
// //                   type="monotone"
// //                   dataKey="Total"
// //                   stroke="#3b82f6"
// //                   strokeWidth={2}
// //                   dot={false}
// //                 />
// //                 <Line
// //                   type="monotone"
// //                   dataKey="Passed"
// //                   stroke="#10b981"
// //                   strokeWidth={2}
// //                   dot={false}
// //                 />
// //                 <Line
// //                   type="monotone"
// //                   dataKey="Failed"
// //                   stroke="#ef4444"
// //                   strokeWidth={2}
// //                   dot={false}
// //                 />
// //               </LineChart>
// //             </ResponsiveContainer>
// //           )}
// //         </div>
// //       </div>

// //       {/* Charts Row 2 */}
// //       <div
// //         className="dashboard-charts-grid"
// //         style={{
// //           display: "grid",
// //           gridTemplateColumns: "1fr 1fr",
// //           gap: 16,
// //           marginBottom: 16,
// //         }}
// //       >
// //         <div className="card">
// //           <h3
// //             style={{
// //               fontSize: 13,
// //               fontWeight: 600,
// //               marginBottom: 16,
// //               color: "var(--text2)",
// //             }}
// //           >
// //             Vendor-wise QC
// //           </h3>
// //           {vendorChart.length === 0 ? (
// //             <p
// //               style={{
// //                 color: "var(--text3)",
// //                 fontSize: 12,
// //                 textAlign: "center",
// //                 padding: 32,
// //               }}
// //             >
// //               No data
// //             </p>
// //           ) : (
// //             <ResponsiveContainer width="100%" height={180}>
// //               <BarChart
// //                 data={vendorChart}
// //                 margin={{ top: 4, right: 4, bottom: 0, left: -20 }}
// //               >
// //                 <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
// //                 <XAxis
// //                   dataKey="name"
// //                   tick={{ fill: "var(--text3)", fontSize: 10 }}
// //                   axisLine={false}
// //                   tickLine={false}
// //                 />
// //                 <YAxis
// //                   tick={{ fill: "var(--text3)", fontSize: 10 }}
// //                   axisLine={false}
// //                   tickLine={false}
// //                 />
// //                 <Tooltip {...tooltipStyle} />
// //                 <Legend wrapperStyle={{ fontSize: 11 }} />
// //                 <Bar dataKey="Pass" fill="#10b981" radius={[3, 3, 0, 0]} />
// //                 <Bar dataKey="Fail" fill="#ef4444" radius={[3, 3, 0, 0]} />
// //               </BarChart>
// //             </ResponsiveContainer>
// //           )}
// //         </div>

// //         <div className="card">
// //           <h3
// //             style={{
// //               fontSize: 13,
// //               fontWeight: 600,
// //               marginBottom: 16,
// //               color: "var(--text2)",
// //             }}
// //           >
// //             Part-wise QC
// //           </h3>
// //           {partChart.length === 0 ? (
// //             <p
// //               style={{
// //                 color: "var(--text3)",
// //                 fontSize: 12,
// //                 textAlign: "center",
// //                 padding: 32,
// //               }}
// //             >
// //               No data
// //             </p>
// //           ) : (
// //             <ResponsiveContainer width="100%" height={180}>
// //               <BarChart
// //                 data={partChart}
// //                 margin={{ top: 4, right: 4, bottom: 0, left: -20 }}
// //               >
// //                 <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
// //                 <XAxis
// //                   dataKey="name"
// //                   tick={{ fill: "var(--text3)", fontSize: 10 }}
// //                   axisLine={false}
// //                   tickLine={false}
// //                 />
// //                 <YAxis
// //                   tick={{ fill: "var(--text3)", fontSize: 10 }}
// //                   axisLine={false}
// //                   tickLine={false}
// //                 />
// //                 <Tooltip {...tooltipStyle} />
// //                 <Legend wrapperStyle={{ fontSize: 11 }} />
// //                 <Bar dataKey="Pass" fill="#3b82f6" radius={[3, 3, 0, 0]} />
// //                 <Bar dataKey="Fail" fill="#f59e0b" radius={[3, 3, 0, 0]} />
// //               </BarChart>
// //             </ResponsiveContainer>
// //           )}
// //         </div>
// //       </div>

// //       {/* Recent Entries Table */}
// //       <div className="card" style={{ padding: 0, overflow: "hidden" }}>
// //         <div
// //           style={{
// //             padding: "14px 20px",
// //             borderBottom: "1px solid var(--border)",
// //             display: "flex",
// //             justifyContent: "space-between",
// //             alignItems: "center",
// //           }}
// //         >
// //           <h3 style={{ fontSize: 13, fontWeight: 600 }}>Recent Entries</h3>
// //           <span className="badge badge-info" style={{ fontSize: 11 }}>
// //             Company-wide
// //           </span>
// //         </div>
// //         <table>
// //           <thead>
// //             <tr>
// //               <th>Product ID</th>
// //               <th>Product</th>
// //               <th>Weight</th>
// //               <th>Range</th>
// //               <th>Result</th>
// //               <th>Serial No.</th>
// //               <th>Time</th>
// //             </tr>
// //           </thead>
// //           <tbody>
// //             {(recentData?.entries || []).length === 0 && (
// //               <tr>
// //                 <td
// //                   colSpan={6}
// //                   style={{
// //                     textAlign: "center",
// //                     padding: 24,
// //                     color: "var(--text3)",
// //                     fontSize: 12,
// //                   }}
// //                 >
// //                   No entries yet
// //                 </td>
// //               </tr>
// //             )}
// //             {(recentData?.entries || []).slice(0, 10).map((e, i) => (
// //               <tr key={i}>
// //                 <td className="mono text3" style={{ fontSize: 11 }}>
// //                   {e.product_code || "—"}
// //                 </td>
// //                 <td>
// //                   <span style={{ fontWeight: 500, fontSize: 12 }}>
// //                     {e.product_name}
// //                   </span>
// //                 </td>
// //                 <td
// //                   className="mono"
// //                   style={{
// //                     fontWeight: 600,
// //                     color:
// //                       e.result === "Pass" ? "var(--success)" : "var(--danger)",
// //                   }}
// //                 >
// //                   {e.weight}g
// //                 </td>
// //                 <td className="mono text3" style={{ fontSize: 11 }}>
// //                   {e.min_weight}–{e.max_weight}g
// //                 </td>
// //                 <td>
// //                   <span
// //                     className={`badge ${e.result === "Pass" ? "badge-success" : "badge-danger"}`}
// //                   >
// //                     {e.result}
// //                   </span>
// //                 </td>
// //                 <td className="mono text3" style={{ fontSize: 11 }}>
// //                   {e.serial_number || "—"}
// //                 </td>
// //                 <td className="text3" style={{ fontSize: 11 }}>
// //                   {new Date(e.recorded_at).toLocaleTimeString()}
// //                 </td>
// //               </tr>
// //             ))}
// //           </tbody>
// //         </table>
// //       </div>
// //     </div>
// //   );
// // }

// import { useEffect, useState, useCallback } from "react";
// import {
//   Activity,
//   AlertTriangle,
//   CheckCircle,
//   RefreshCw,
//   Filter,
// } from "lucide-react";
// import KPICard from "../../components/charts/KPICard";
// import { weightAPI, dashboardAPI, companyAPI } from "../../services/api";
// import { useAuth } from "../../context/AuthContext";
// import {
//   AreaChart,
//   Area,
//   LineChart,
//   Line,
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
//   Legend,
// } from "recharts";

// const REFRESH_INTERVAL = 1000;

// export default function ClientDashboard() {
//   const { user } = useAuth();

//   const [recentData, setRecentData] = useState(null); // recent entries table sathi
//   const [analytics, setAnalytics] = useState(null); // charts + KPIs sathi
//   const [vendors, setVendors] = useState([]);

//   const [selectedVendor, setSelectedVendor] = useState("");
//   const [days, setDays] = useState(7);
//   const [loading, setLoading] = useState(true);
//   const [err, setErr] = useState("");
//   const [lastUpdated, setLastUpdated] = useState(null);
//   const [live, setLive] = useState(true);

//   // Vendor list
//   useEffect(() => {
//     companyAPI
//       .list()
//       .then((r) => setVendors(r.data || []))
//       .catch(() => setVendors([]));
//   }, []);

//   // Recent entries (table sathi)
//   const fetchRecent = useCallback(async () => {
//     try {
//       const params = { limit: 10 };
//       if (selectedVendor) params.company_id = selectedVendor;
//       const r = await weightAPI.list(params);
//       setRecentData(r.data);
//     } catch (e) {
//       console.error("Recent data fetch failed:", e.message);
//     }
//   }, [selectedVendor]);

//   // Analytics (KPIs + charts sathi)
//   const fetchAnalytics = useCallback(
//     async (silent = false) => {
//       if (!silent) setLoading(true);
//       try {
//         const r = await dashboardAPI.analytics(days, selectedVendor || null);
//         setAnalytics(r.data);
//         setLastUpdated(new Date());
//         setErr("");
//       } catch (e) {
//         setErr(e.message);
//       } finally {
//         setLoading(false);
//       }
//     },
//     [days, selectedVendor],
//   );

//   useEffect(() => {
//     fetchAnalytics();
//     fetchRecent();
//   }, [selectedVendor, days, fetchAnalytics, fetchRecent]);

//   useEffect(() => {
//     if (!live) return;
//     const interval = setInterval(() => {
//       fetchAnalytics(true);
//       fetchRecent();
//     }, REFRESH_INTERVAL);
//     return () => clearInterval(interval);
//   }, [live, fetchAnalytics, fetchRecent]);

//   if (loading && !analytics)
//     return <div style={{ padding: 28, color: "var(--text2)" }}>Loading...</div>;
//   if (err && !analytics)
//     return (
//       <div style={{ padding: 28, color: "var(--danger)" }}>Error: {err}</div>
//     );

//   // ── KPIs: analytics.daily madhe saglya days cha sum ────────
//   const daily = analytics?.daily || [];
//   const hourly = analytics?.hourly || [];
//   const vendor = analytics?.vendor || [];
//   const part = analytics?.part || [];

//   const totalChecks = daily.reduce((s, d) => s + d.qc_pass + d.qc_fail, 0);
//   const totalPassed = daily.reduce((s, d) => s + d.qc_pass, 0);
//   const totalFailed = daily.reduce((s, d) => s + d.qc_fail, 0);
//   const passRate =
//     totalChecks > 0 ? ((totalPassed / totalChecks) * 100).toFixed(1) : "0.0";

//   // Chart data
//   const dailyChart = daily.map((d) => ({
//     day: new Date(d.day).toLocaleDateString("en-IN", {
//       month: "short",
//       day: "numeric",
//     }),
//     Pass: d.qc_pass,
//     Fail: d.qc_fail,
//   }));
//   const hourlyChart = hourly.map((h) => ({
//     hour: `${String(h.hour).padStart(2, "0")}:00`,
//     Total: h.total_inspected,
//     Passed: h.passed,
//     Failed: h.total_inspected - h.passed,
//   }));
//   const vendorChart = vendor.map((v) => ({
//     name:
//       v.vendor_name?.length > 14
//         ? v.vendor_name.slice(0, 14) + "…"
//         : v.vendor_name,
//     Pass: v.qc_pass,
//     Fail: v.qc_fail,
//   }));
//   const partChart = part.map((p) => ({
//     name: p.product_code || p.product_name?.slice(0, 10),
//     Pass: p.qc_pass,
//     Fail: p.qc_fail,
//   }));

//   const tooltipStyle = {
//     contentStyle: {
//       background: "var(--surface)",
//       border: "1px solid var(--border2)",
//       borderRadius: 8,
//     },
//     labelStyle: { color: "var(--text2)", fontSize: 11 },
//   };

//   return (
//     <div style={{ padding: 28 }}>
//       {/* Header */}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "flex-start",
//           marginBottom: 24,
//         }}
//       >
//         <div>
//           <h1
//             style={{ fontSize: 20, fontWeight: 700, letterSpacing: "-0.02em" }}
//           >
//             Welcome, {user?.name}
//           </h1>
//           <p style={{ color: "var(--text2)", fontSize: 13, marginTop: 2 }}>
//             {user?.company_name || "Your quality dashboard"}
//           </p>
//         </div>
//         <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
//           {lastUpdated && (
//             <span style={{ fontSize: 11, color: "var(--text3)" }}>
//               Updated {lastUpdated.toLocaleTimeString()}
//             </span>
//           )}
//           <button
//             onClick={() => {
//               fetchAnalytics();
//               fetchRecent();
//             }}
//             title="Refresh"
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               padding: "8px",
//               borderRadius: 6,
//               border: "1px solid var(--border2)",
//               background: "var(--surface)",
//               color: "var(--text2)",
//               cursor: "pointer",
//             }}
//           >
//             <RefreshCw size={14} />
//           </button>
//         </div>
//       </div>

//       {/* ── KPI Cards — analytics data वरून (real numbers!) ── */}
//       <div
//         className="dashboard-cards-grid"
//         style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(4, 1fr)",
//           gap: 14,
//           marginBottom: 24,
//         }}
//       >
//         <KPICard
//           label={`Total Checks (${days}d)`}
//           value={totalChecks}
//           icon={Activity}
//           color="var(--accent)"
//         />
//         <KPICard
//           label="Passed"
//           value={totalPassed}
//           icon={CheckCircle}
//           color="var(--success)"
//         />
//         <KPICard
//           label="Failed"
//           value={totalFailed}
//           icon={AlertTriangle}
//           color="var(--danger)"
//         />
//         <KPICard
//           label="Pass Rate"
//           value={passRate}
//           unit="%"
//           icon={CheckCircle}
//           color="var(--warn)"
//         />
//       </div>

//       {/* Vendor + Days Filter */}
//       <div
//         className="flex-responsive"
//         style={{
//           display: "flex",
//           alignItems: "center",
//           gap: 10,
//           marginBottom: 20,
//           padding: "10px 14px",
//           background: "var(--surface)",
//           border: "1px solid var(--border)",
//           borderRadius: 8,
//         }}
//       >
//         <Filter size={14} color="var(--text3)" />
//         <span style={{ fontSize: 12, color: "var(--text3)", fontWeight: 500 }}>
//           Filter:
//         </span>
//         <select
//           value={selectedVendor}
//           onChange={(e) => setSelectedVendor(e.target.value)}
//           style={{
//             padding: "4px 10px",
//             borderRadius: 6,
//             border: "1px solid var(--border2)",
//             background: "var(--surface)",
//             color: "var(--text)",
//             fontSize: 12,
//             cursor: "pointer",
//           }}
//         >
//           <option value="">All Companies</option>
//           {vendors.map((v) => (
//             <option key={v.id} value={v.id}>
//               {v.name}
//             </option>
//           ))}
//         </select>
//         {[7, 14, 30].map((d) => (
//           <button
//             key={d}
//             onClick={() => setDays(d)}
//             style={{
//               padding: "4px 10px",
//               borderRadius: 6,
//               fontSize: 12,
//               border:
//                 days === d
//                   ? "1px solid var(--accent)"
//                   : "1px solid var(--border2)",
//               background:
//                 days === d ? "rgba(59,130,246,0.1)" : "var(--surface)",
//               color: days === d ? "var(--accent)" : "var(--text2)",
//               cursor: "pointer",
//               fontWeight: days === d ? 600 : 400,
//             }}
//           >
//             {d}d
//           </button>
//         ))}
//       </div>

//       {/* Charts Row 1 */}
//       <div
//         className="dashboard-charts-grid"
//         style={{
//           display: "grid",
//           gridTemplateColumns: "1fr 1fr",
//           gap: 16,
//           marginBottom: 16,
//         }}
//       >
//         <div className="card">
//           <h3
//             style={{
//               fontSize: 13,
//               fontWeight: 600,
//               marginBottom: 16,
//               color: "var(--text2)",
//             }}
//           >
//             Daily QC Trend (Last {days} days)
//           </h3>
//           {dailyChart.length === 0 ? (
//             <p
//               style={{
//                 color: "var(--text3)",
//                 fontSize: 12,
//                 textAlign: "center",
//                 padding: 32,
//               }}
//             >
//               No data
//             </p>
//           ) : (
//             <ResponsiveContainer width="100%" height={180}>
//               <AreaChart
//                 data={dailyChart}
//                 margin={{ top: 4, right: 4, bottom: 0, left: -20 }}
//               >
//                 <defs>
//                   <linearGradient id="passGrad" x1="0" y1="0" x2="0" y2="1">
//                     <stop offset="5%" stopColor="#10b981" stopOpacity={0.25} />
//                     <stop offset="95%" stopColor="#10b981" stopOpacity={0} />
//                   </linearGradient>
//                   <linearGradient id="failGrad" x1="0" y1="0" x2="0" y2="1">
//                     <stop offset="5%" stopColor="#ef4444" stopOpacity={0.25} />
//                     <stop offset="95%" stopColor="#ef4444" stopOpacity={0} />
//                   </linearGradient>
//                 </defs>
//                 <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
//                 <XAxis
//                   dataKey="day"
//                   tick={{ fill: "var(--text3)", fontSize: 10 }}
//                   axisLine={false}
//                   tickLine={false}
//                 />
//                 <YAxis
//                   tick={{ fill: "var(--text3)", fontSize: 10 }}
//                   axisLine={false}
//                   tickLine={false}
//                 />
//                 <Tooltip {...tooltipStyle} />
//                 <Legend wrapperStyle={{ fontSize: 11 }} />
//                 <Area
//                   type="monotone"
//                   dataKey="Pass"
//                   stroke="#10b981"
//                   fill="url(#passGrad)"
//                   strokeWidth={2}
//                   dot={false}
//                 />
//                 <Area
//                   type="monotone"
//                   dataKey="Fail"
//                   stroke="#ef4444"
//                   fill="url(#failGrad)"
//                   strokeWidth={2}
//                   dot={false}
//                 />
//               </AreaChart>
//             </ResponsiveContainer>
//           )}
//         </div>

//         <div className="card">
//           <h3
//             style={{
//               fontSize: 13,
//               fontWeight: 600,
//               marginBottom: 16,
//               color: "var(--text2)",
//             }}
//           >
//             Hourly Inspections (Today)
//           </h3>
//           {hourlyChart.length === 0 ? (
//             <p
//               style={{
//                 color: "var(--text3)",
//                 fontSize: 12,
//                 textAlign: "center",
//                 padding: 32,
//               }}
//             >
//               No data yet today
//             </p>
//           ) : (
//             <ResponsiveContainer width="100%" height={180}>
//               <LineChart
//                 data={hourlyChart}
//                 margin={{ top: 4, right: 4, bottom: 0, left: -20 }}
//               >
//                 <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
//                 <XAxis
//                   dataKey="hour"
//                   tick={{ fill: "var(--text3)", fontSize: 10 }}
//                   axisLine={false}
//                   tickLine={false}
//                 />
//                 <YAxis
//                   tick={{ fill: "var(--text3)", fontSize: 10 }}
//                   axisLine={false}
//                   tickLine={false}
//                 />
//                 <Tooltip {...tooltipStyle} />
//                 <Legend wrapperStyle={{ fontSize: 11 }} />
//                 <Line
//                   type="monotone"
//                   dataKey="Total"
//                   stroke="#3b82f6"
//                   strokeWidth={2}
//                   dot={false}
//                 />
//                 <Line
//                   type="monotone"
//                   dataKey="Passed"
//                   stroke="#10b981"
//                   strokeWidth={2}
//                   dot={false}
//                 />
//                 <Line
//                   type="monotone"
//                   dataKey="Failed"
//                   stroke="#ef4444"
//                   strokeWidth={2}
//                   dot={false}
//                 />
//               </LineChart>
//             </ResponsiveContainer>
//           )}
//         </div>
//       </div>

//       {/* Charts Row 2 */}
//       <div
//         className="dashboard-charts-grid"
//         style={{
//           display: "grid",
//           gridTemplateColumns: "1fr 1fr",
//           gap: 16,
//           marginBottom: 16,
//         }}
//       >
//         <div className="card">
//           <h3
//             style={{
//               fontSize: 13,
//               fontWeight: 600,
//               marginBottom: 16,
//               color: "var(--text2)",
//             }}
//           >
//             Vendor-wise QC
//           </h3>
//           {vendorChart.length === 0 ? (
//             <p
//               style={{
//                 color: "var(--text3)",
//                 fontSize: 12,
//                 textAlign: "center",
//                 padding: 32,
//               }}
//             >
//               No data
//             </p>
//           ) : (
//             <ResponsiveContainer width="100%" height={180}>
//               <BarChart
//                 data={vendorChart}
//                 margin={{ top: 4, right: 4, bottom: 0, left: -20 }}
//               >
//                 <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
//                 <XAxis
//                   dataKey="name"
//                   tick={{ fill: "var(--text3)", fontSize: 10 }}
//                   axisLine={false}
//                   tickLine={false}
//                 />
//                 <YAxis
//                   tick={{ fill: "var(--text3)", fontSize: 10 }}
//                   axisLine={false}
//                   tickLine={false}
//                 />
//                 <Tooltip {...tooltipStyle} />
//                 <Legend wrapperStyle={{ fontSize: 11 }} />
//                 <Bar dataKey="Pass" fill="#10b981" radius={[3, 3, 0, 0]} />
//                 <Bar dataKey="Fail" fill="#ef4444" radius={[3, 3, 0, 0]} />
//               </BarChart>
//             </ResponsiveContainer>
//           )}
//         </div>

//         <div className="card">
//           <h3
//             style={{
//               fontSize: 13,
//               fontWeight: 600,
//               marginBottom: 16,
//               color: "var(--text2)",
//             }}
//           >
//             Part-wise QC
//           </h3>
//           {partChart.length === 0 ? (
//             <p
//               style={{
//                 color: "var(--text3)",
//                 fontSize: 12,
//                 textAlign: "center",
//                 padding: 32,
//               }}
//             >
//               No data
//             </p>
//           ) : (
//             <ResponsiveContainer width="100%" height={180}>
//               <BarChart
//                 data={partChart}
//                 margin={{ top: 4, right: 4, bottom: 0, left: -20 }}
//               >
//                 <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
//                 <XAxis
//                   dataKey="name"
//                   tick={{ fill: "var(--text3)", fontSize: 10 }}
//                   axisLine={false}
//                   tickLine={false}
//                 />
//                 <YAxis
//                   tick={{ fill: "var(--text3)", fontSize: 10 }}
//                   axisLine={false}
//                   tickLine={false}
//                 />
//                 <Tooltip {...tooltipStyle} />
//                 <Legend wrapperStyle={{ fontSize: 11 }} />
//                 <Bar dataKey="Pass" fill="#3b82f6" radius={[3, 3, 0, 0]} />
//                 <Bar dataKey="Fail" fill="#f59e0b" radius={[3, 3, 0, 0]} />
//               </BarChart>
//             </ResponsiveContainer>
//           )}
//         </div>
//       </div>

//       {/* Recent Entries Table */}
//       <div className="card" style={{ padding: 0, overflow: "hidden" }}>
//         <div
//           style={{
//             padding: "14px 20px",
//             borderBottom: "1px solid var(--border)",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//           }}
//         >
//           <h3 style={{ fontSize: 13, fontWeight: 600 }}>Recent Entries</h3>
//           <span className="badge badge-info" style={{ fontSize: 11 }}>
//             Company-wide
//           </span>
//         </div>
//         <table>
//           <thead>
//             <tr>
//               <th>Product ID</th>
//               <th>Product</th>
//               <th>Weight</th>
//               <th>Range</th>
//               <th>Result</th>
//               <th>Serial No.</th>
//               <th>Time</th>
//             </tr>
//           </thead>
//           <tbody>
//             {(recentData?.entries || []).length === 0 && (
//               <tr>
//                 <td
//                   colSpan={6}
//                   style={{
//                     textAlign: "center",
//                     padding: 24,
//                     color: "var(--text3)",
//                     fontSize: 12,
//                   }}
//                 >
//                   No entries yet
//                 </td>
//               </tr>
//             )}
//             {(recentData?.entries || []).slice(0, 10).map((e, i) => (
//               <tr key={i}>
//                 <td className="mono text3" style={{ fontSize: 11 }}>
//                   {e.product_code || "—"}
//                 </td>
//                 <td>
//                   <span style={{ fontWeight: 500, fontSize: 12 }}>
//                     {e.product_name}
//                   </span>
//                 </td>
//                 <td
//                   className="mono"
//                   style={{
//                     fontWeight: 600,
//                     color:
//                       e.result === "Pass" ? "var(--success)" : "var(--danger)",
//                   }}
//                 >
//                   {e.weight}g
//                 </td>
//                 <td className="mono text3" style={{ fontSize: 11 }}>
//                   {e.min_weight}–{e.max_weight}g
//                 </td>
//                 <td>
//                   <span
//                     className={`badge ${e.result === "Pass" ? "badge-success" : "badge-danger"}`}
//                   >
//                     {e.result}
//                   </span>
//                 </td>
//                 <td className="mono text3" style={{ fontSize: 11 }}>
//                   {e.serial_number || "—"}
//                 </td>
//                 <td className="text3" style={{ fontSize: 11 }}>
//                   {new Date(e.recorded_at).toLocaleTimeString()}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }

// ************************************************
// ajay:code 04-08-26
import CompanyDashboard from "../company/Dashboard";

// Client dashboard intentionally company dashboard jaisa hi hai — same
// product/date/time SPC view, same 1-second live refresh. Underlying APIs
// (productAPI.list, weightAPI.spcData, weightAPI.list) already company_id
// se scoped hoti hai server-side, aur client_user ka company_id hi unki
// managing/vendor company hoti hai — isliye ye automatically sirf unhi ki
// company ka data dikhayega, kuch extra karne ki zaroorat nahi.
export default function ClientDashboard() {
  return <CompanyDashboard />;
}
